/* eslint-disable @typescript-eslint/no-explicit-any */

export const parseUrlSearch = <T>(search: string): T => {
  return search
    .substring(1)
    .split("&")
    .reduce((obj, v) => {
      const pair = v.split("=");
      if (decodeURIComponent(pair[0])) {
        obj[decodeURIComponent(pair[0])] = pair[1] ? decodeURIComponent(pair[1]) : undefined;
      }
      return obj;
    }, Object.create(null));
};

export const strToBool = (s: string) => {
  return s?.toLowerCase() !== "false";
};
